import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, typography, palette, shadows }) => ({
  tooltip: {
    backgroundColor: palette.common.white,
    color: palette.text.primary,
    padding: 0,
    maxWidth: 360,
    boxShadow: shadows[4],
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: spacing(1.5)
  },
  tooltipArrow: {
    color: palette.common.white,
    '&::before': {
      backgroundColor: palette.common.white,
      border: `1px solid ${palette.grey[200]}`
    }
  },
  tooltipContent: {
    padding: spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1.5)
  },
  tooltipTitle: {
    ...typography.heading.h4,
    fontSize: '1rem',
    fontWeight: typography.weight.bold,
    color: palette.text.primary,
    margin: 0,
    lineHeight: 1.3
  },
  tooltipDescription: {
    ...typography.body.m,
    fontSize: '0.875rem',
    color: palette.text.secondary,
    lineHeight: 1.5,
    margin: 0
  },
  scoresHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing(2),
    marginTop: spacing(1)
  },
  scoreItemCompact: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.25),
    flex: 1
  },
  scoreItemWithIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0.5)
  },
  scoreLabelCompact: {
    ...typography.body.xs,
    fontSize: '0.6875rem',
    color: palette.text.secondary,
    fontWeight: typography.weight.medium
  },
  scoreValueCompact: {
    ...typography.heading.h4,
    fontSize: '1.5rem',
    fontWeight: typography.weight.bold,
    color: palette.text.primary,
    lineHeight: 1.2
  },
  scoreValuePotentialCompact: {
    ...typography.heading.h4,
    fontSize: '1.5rem',
    fontWeight: typography.weight.bold,
    lineHeight: 1.2
  },
  trendingIcon: {
    fontSize: '0.875rem'
  },
  progressBarWrapper: {
    position: 'relative',
    width: '100%',
    height: 12,
    marginTop: spacing(1.5),
    borderRadius: spacing(1.5),
    overflow: 'hidden'
  },
  progressBarBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: palette.grey[200],
    borderRadius: spacing(1.5)
  },
  progressBarPotential: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: spacing(1.5),
    zIndex: 1,
    transition: 'width 0.3s ease'
  },
  progressBarFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: spacing(1.5),
    zIndex: 2,
    transition: 'width 0.3s ease'
  },
  benchmarkMarker: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 2,
    backgroundColor: palette.grey[600],
    zIndex: 3,
    transform: 'translateX(-50%)'
  },
  progressLabels: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2),
    marginTop: spacing(0.75),
    justifyContent: 'flex-start'
  },
  progressLabelWithDot: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0.5)
  },
  progressDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0
  },
  progressLabelText: {
    ...typography.body.xs,
    fontSize: '0.625rem',
    color: palette.text.secondary,
    fontWeight: typography.weight.medium,
    whiteSpace: 'nowrap'
  },
  improvementContainer: {
    backgroundColor: palette.grey[50],
    borderRadius: spacing(0.75),
    padding: spacing(1),
    marginTop: spacing(1),
    textAlign: 'center'
  },
  improvementText: {
    ...typography.body.xs,
    fontSize: '0.6875rem',
    color: palette.text.secondary,
    margin: 0,
    '& strong': {
      fontWeight: typography.weight.bold,
      color: palette.text.primary
    }
  },
  iconButton: {
    padding: spacing(0.5),
    color: palette.text.secondary,
    opacity: 0.6,
    '&:hover': {
      opacity: 1,
      backgroundColor: palette.action.hover
    }
  },
  infoIcon: {
    fontSize: 18
  }
}))
